import { DeviceLinkDto, ControlledDto, ControllerDto } from '../../installation/api'

export const getEmcPairingId = (deviceLink: Nullable<DeviceLinkDto>): string => {
  /** OR (||) is used instead of null coalesce (??) because deviceShortUuid might be an empty string. In that case the deviceId is returned. */
  return deviceLink.deviceShortUuid || deviceLink.deviceId || ''
}

export const getStoragePairingId = (deviceLink: Nullable<DeviceLinkDto>): string => {
  /** OR (||) is used instead of null coalesce (??) because deviceShortUuid might be an empty string. In that case the deviceId is returned. */
  return deviceLink.deviceShortUuid || deviceLink.deviceId || ''
}

export const getEvsePairingId = (evse: Nullable<ControlledDto>): string => {
  if (evse.media === 'ModbusTCP') return evse.mediaParameters?.macAddress ?? ''
  if (evse.media === 'EEBus') return evse.mediaParameters?.ski ?? ''
  return ''
}

export const getIoPairingId = (io: Nullable<ControllerDto>): string => {
  if (io.type === 'IOController') {
    if (io.media === 'ModbusRTU') return (io.mediaParameters?.address ?? '').toString()

    if (io.media === 'Storage') return io.mediaParameters?.deviceShortUuid || io.mediaParameters?.deviceId?.toString() || ''

    return ''
  }
  if (io.type === 'MyPvHeater') return io.mediaParameters?.serialNumber ?? ''
  if (io.type === 'HpWithISG') return io.mediaParameters?.macAddress ?? ''
  return ''
}
